module.exports = __webpack_public_path__ + "static/strategi-c92c78307923d489b7dab017af09954e.png";